<template>
  <div>
    <v-subheader>Select allowed locations for Service module</v-subheader>
    <div v-if="shouldSpecifyBases">
      <v-autocomplete
        v-model="serviceAllowBasesDirty"
        v-validate="'required'"
        :items="bases.data"
        :loading="bases.loading"
        name="service_allow_bases"
        item-value="id"
        item-text="name"
        :item-disabled="item => !currentUserServiceAllowedBases.find(b => b.id === item.id)"
        label="Select bases"
        autocomplete="disable"
        outlined
        return-object
        single-line
        multiple
        small-chips
        deletable-chips
        data-vv-as="bases"
        :error-messages="veeErrors.collect('service_allow_bases')"
      />
    </div>
    <div v-else-if="shouldSpecifyCountries">
      <v-autocomplete
        v-model="serviceAllowCountriesDirty"
        v-validate="'required'"
        :items="countries.data"
        :loading="countries.loading"
        name="service_allow_countries"
        item-value="id"
        item-text="name"
        :item-disabled="item => !currentUserServiceAllowedCountries.find(c => c.id === item.id)"
        label="Select countries"
        autocomplete="disable"
        outlined
        single-line
        return-object
        multiple
        small-chips
        deletable-chips
        data-vv-as="countries"
        :error-messages="veeErrors.collect('service_allow_countries')"
      />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ServiceAllowedLocationsList',
    inject: [ 'parentValidator' ],
    props: {
      shouldSpecifyBases: {
        type: Boolean,
        default: false
      },
      shouldSpecifyCountries: {
        type: Boolean,
        default: false
      },
      serviceAllowBases: {
        type: Array,
        default: () => []
      },
      serviceAllowCountries: {
        type: Array,
        default: () => []
      }
    },
    computed: {
      currentUserServiceAllowedCountries: function () {
        return this.$store.state.auth.user.service_allow_countries
      },
      currentUserServiceAllowedBases: function () {
        return this.$store.state.auth.user.service_allow_bases
      },
      countries() {
        return this.$store.getters['settings/charteringCountries']
      },
      bases() {
        return this.$store.state.business.bases
      },
      serviceAllowBasesDirty: {
        get: function () {
          return this.serviceAllowBases
        },
        set: function (val) {
          this.$emit('update:serviceAllowBases', val)
        }
      },
      serviceAllowCountriesDirty: {
        get: function () {
          return this.serviceAllowCountries
        },
        set: function (val) {
          this.$emit('update:serviceAllowCountries', val)
        }
      }
    },
    created () {
      this.$validator = this.parentValidator
    }
  }
</script>
